<template>
  <div class="section-spacing-20 full-width">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="font-normal">Appointment Colors Customization</h4>
      <AppointmentColorsLegend />
    </div>
    <div>
      Edit appointment status colors on the schedule board by selecting from the
      color picker or entering a HEX code.
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatusColorCard
        v-for="customization in statusCustomizations"
        :key="customization.id"
        class="status-card"
        :customization="customization"
        @save="handleSave"
        @reset-default="handleReset"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";

import AppointmentColorsLegend from "@/Scheduler/AppointmentColorsLegend.vue";
import { CustomizationRecord } from "../customizations";
import StatusColorCard from "../StatusColorCard.vue";

const store = useStore();

const statusCustomizations: ComputedRef<{ [k: string]: CustomizationRecord }> =
  computed(() => {
    return store.getters.sortedAppointmentStatusCustomizations;
  });

async function handleSave(customization) {
  await store.dispatch("updateCustomizationSetting", {
    customization: {
      key: customization.key,
      value: customization.value
    }
  });
  store.dispatch("fetchTenantCustomizations");
}

async function handleReset(customization) {
  await store.dispatch("deleteCustomizationSetting", customization.key);
  store.dispatch("fetchTenantCustomizations");
}
</script>

<style lang="scss" scoped></style>
